import React, { useEffect, useState } from "react";
import bg from "./spi.jpg";
import qr from "./qr.jpeg";

const Donations = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const styles = {
    container: {
      minHeight: "100vh",
      backgroundImage: `url(${bg})`,
      backgroundSize: "cover",
      backgroundPosition: isMobile ? "right center" : "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: isMobile ? "scroll" : "fixed",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px",
      fontFamily: '"Arial Black", sans-serif'
    },

    name: {
      fontSize: isMobile ? "2.5rem" : "4rem",
      fontWeight: "900",
      color: "#fff",
      textTransform: "uppercase",
      marginBottom: "30px",
      textShadow: "6px 6px 0px #000",
      textAlign: "center"
    },

    card: {
      backgroundColor: "#ffffff",
      border: "6px solid #000",
      padding: isMobile ? "25px" : "40px",
      boxShadow: "15px 15px 0px #000",
      textAlign: "center",
      maxWidth: "400px",
      width: "100%"
    },

    qrImage: {
      width: isMobile ? "200px" : "250px",
      maxWidth: "80vw",
      height: "auto",
      marginBottom: "25px",
      border: "4px solid #000"
    },

    thankYou: {
      fontWeight: "900",
      fontSize: isMobile ? "1rem" : "1.2rem",
      textTransform: "uppercase",
      color: "black"
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.name}>ARUSH</div>

      <div style={styles.card}>
        <h2
          style={{
            fontWeight: "900",
            fontSize: isMobile ? "1.5rem" : "2rem",
            marginBottom: "20px",
            color: "black"
          }}
        >
          DONATIONS
        </h2>

        <img src={qr} alt="Donation QR" style={styles.qrImage} />

        <div style={styles.thankYou}>
          THANK YOU FOR SUPPORTING MY WORK ❤️
        </div>
      </div>
    </div>
  );
};

export default Donations;